import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';
import { enableAkitaProdMode } from '@datorama/akita';

import { SharedModule } from '../shared/shared.module';
import { environment } from '../../environments/environment';
import { CsProjectsComponent } from './cs-projects.component';
import { AddCsProjectDialogComponent } from './add-dialog/add-cs-project-dialog.component';
import { CsProjectFormComponent } from './project-form/cs-project-form.component';
import { DeleteCsProjectDialogComponent } from './delete-dialog/delete-cs-project-dialog.component';


if (environment.production) {
  enableAkitaProdMode();
}

@NgModule({
  declarations: [
    CsProjectsComponent,
    AddCsProjectDialogComponent,
    CsProjectFormComponent,
    DeleteCsProjectDialogComponent ],
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule ],
  exports: [ CsProjectFormComponent ],
  providers: [
    {
      provide: NG_ENTITY_SERVICE_CONFIG,
      useValue: {
        baseUrl: environment.offerApiUrl
      }
    }
  ],
})
export class CsProjectsModule { }
